import React from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import { connect } from "react-redux";
import Table from "../../Common/Table";
import TableFields from "../../../constants/FeatureConfig/ActionsTableFields.json";
import { getPath } from "../../../utils";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import BlankStateV2 from "../../Common/BlankStateV2";

const ActionsModal = (props) => {
  const { activeActions, handleClose } = props;

  const getFieldValue = (action, key, index) => {
    switch (key) {
      case "number":
        return <p style={{ fontSize: "1rem" }}>{index + 1}</p>;
      default:
        return <p style={{ fontSize: "1rem" }}>{action}</p>;
    }
  };

  return (
    <NoFooterModal
      header={true}
      heading={"Actions"}
      handleClose={handleClose}
      id="ActionsModal"
    >
      <ActionSection>
        <p className="sectionHeading">Read Actions</p>
      </ActionSection>
      <Table
        list={getPath(activeActions, "read", [])}
        getFieldValue={getFieldValue}
        fields={TableFields}
        blankStateComponent={<BlankStateV2 heading={"No Read Actions"} />}
      />

      <div style={{ height: "20px" }}></div>
      <ActionSection>
        <p className="sectionHeading">Write Actions</p>
      </ActionSection>
      <Table
        list={getPath(activeActions, "write", [])}
        getFieldValue={getFieldValue}
        fields={TableFields}
        blankStateComponent={<BlankStateV2 heading={"No Write Actions"} />}
      />
    </NoFooterModal>
  );
};

export default connect()(ActionsModal);

const ActionSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.3rem;
    font-size: 5px;
  }
`;
